module.exports = __webpack_public_path__ + "static/Ankylosaurus-6b6158f7f5add98c06e91aef290b51fd.jpg";